<template>
<div class="chapter">
<div class="inner_page">
<div class="blockquote">
<p class="center1"><a id="page_7"></a>Three fishers went sailing out into the West,</p>
<p class="left">Out into the West as the sun went down;</p>
<p class="left">Each thought on the woman who lov’d him the best</p>
<p class="left">And the children stood watching them out of the town …</p>
<p class="centerj">C<span class="smallcap">HARLES</span> K<span class="smallcap">INGSLEY</span>, ‘T<span class="smallcap">HREE</span> F<span class="smallcap">ISHERS</span>’ (1851)</p>
</div>
<div class="blockquote">
<p class="center1">Dusk off the Foreland – the last light going</p>
<p class="left">And the traffic crowding through,</p>
<p class="left">And five damned trawlers with their sirens blowing Heading the whole review!</p>
<p class="left">‘Sweep completed in the fairway.</p>
<p class="left">No more mines remain.</p>
<p class="left">Send back <em class="italic">Unity</em>, <em class="italic">Claribel</em>, <em class="italic">Assyrian</em>, <em class="italic">Stormcock</em>, and <em class="italic">Golden Gain</em>’.</p>
<p class="centerj">R<span class="smallcap">UDYARD</span> K<span class="smallcap">IPLING</span>, ‘M<span class="smallcap">INESWEEPERS</span>’ (<em class="italic">S<span class="smallcap">ONGS</span> <span class="smallcap">FROM</span> B<span class="smallcap">OOKS</span></em>,1914)</p>
</div>
<div class="blockquote">
<p class="center1">She’d a gun at her bow that was Newcastle’s best,</p>
<p class="left">And a gun at her stern that was fresh from the Clyde,</p>
<p class="left">And a secret her skipper had never confessed, Not even at dawn, to his newly wed bride;</p>
<p class="left">And a wireless that whispered above like a gnome, The laughter of London, the boasts of Berlin.</p>
<p class="left">O, it may have been mermaids that lured her from home,</p>
<p class="left">But nobody knew where <em class="italic">Kilmeny</em> had been.</p>
</div>
<div class="blockquote">
<p class="center1">It was dark when <em class="italic">Kilmeny</em> came home from her quest,</p>
<p class="left">With her bridge dabbled red where her skipper had died;</p>
<p class="left">But she moved like a bride with a rose at her breast;</p>
<p class="left">And ‘Well done, <em class="italic">Kilmeny</em>!’ the admiral cried.</p>
<p class="left">Now at sixty-four fathom a conger may come,</p>
<p class="left">And nose at the bones of a drowned submarine;</p>
<p class="left">But late in the evening <em class="italic">Kilmeny</em> came home,</p>
<p class="left">And nobody knew where <em class="italic">Kilmeny</em> had been.</p>
<p class="centerj">A<span class="smallcap">LFRED</span> N<span class="smallcap">OYES</span>, ‘K<span class="smallcap">ILMENY</span> – A S<span class="smallcap">ONG</span> <span class="smallcap">OF THE</span> T<span class="smallcap">RAWLERS</span>’ (1917)</p>
</div>
<div class="img_container"><a id="page_8"></a>
<img alt="Image" src="images/p008_01.jpg"/>
<p class="caption"><em class="italic">Syringa</em> was a ‘Tree’-class Admiralty trawler purchased in 1935, previously named <em class="italic">Cape Kanin</em> and sold back into trade in 1947 as <em class="italic">Davaar Island</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Frontmatter02.vue?0f837731